import React from 'react';
import {IChecklistItemModel} from '@src/@interfaces/models/Checklist/IChecklistItemModel';
import usePermissionGranted from '@src/hooks/usePermissionGranted';
import ChecklistItem from '@views/orders/ChecklistItem';
import {ICheckedChecklistItemModel} from '@src/@interfaces/models/Checklist/ICheckedChecklistItemModel';

export type Props = {
    items: IChecklistItemModel[],
    checkedItems?: ICheckedChecklistItemModel[],
    onItemStateChanged?: (items: IChecklistItemModel, state: boolean) => Promise<void>,
    canChangeItemsStatePermission?: string | string[],
    disabled?: boolean,
    readonly?: boolean,
};

export default function Checklist(props: Props) {
    const canChange = usePermissionGranted(props.canChangeItemsStatePermission ?? []);

    const {onItemStateChanged} = props;
    const changingAvailable = canChange && onItemStateChanged != null;

    return <div>
        {props.items.map(item => {
            return <ChecklistItem
                    key={item.id}
                    item={item}
                    checkedItems={props.checkedItems}
                    onChange={changingAvailable ? onItemStateChanged : undefined}
                    disabled={props.disabled}
                    readonly={props.readonly}
            />;
        })}
    </div>;
}
